import { type VariantProps, cva } from 'class-variance-authority'

export { default as Alert } from './Alert.vue'
export { default as AlertTitle } from './AlertTitle.vue'
export { default as AlertDescription } from './AlertDescription.vue'

export const alertVariants = cva(
  'rounded-md p-4',
  {
    variants: {
      variant: {
        default: 'border-slate-400 bg-slate-50 text-slate-950',
        informative: 'border-blue-400 bg-blue-50 text-blue-800',
        postive: 'border-green-400 bg-green-50 text-green-800',
        notice: 'border-yellow-400 bg-yellow-50 text-yellow-800',
        negative: 'border-red-400 bg-red-50 text-red-700',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
)

export type AlertVariants = VariantProps<typeof alertVariants>
